import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getAccountsToken, logout } from '@/lib/accounts';
import { initializePendo } from '@/lib/pendo';
import { trpc } from '@/lib/trpc';
import useAuthStore from '@/stores/auth';

export const useAccounts = () => {
  const isAuthenticated = useAuthStore(({ isAuthenticated }) => isAuthenticated());
  const { setAuthData, setAuthCompleted } = useAuthStore(({ setAuthData, setAuthCompleted }) => ({
    setAuthData,
    setAuthCompleted
  }));

  const { data: accountsCode } = useQuery({
    queryKey: ['accounts', 'token'],
    queryFn: getAccountsToken
  });

  const {
    data: authData,
    refetch,
    error
  } = trpc.auth.login.useQuery({ token: accountsCode! }, { enabled: !!accountsCode });

  useEffect(() => {
    if (!authData) {
      return;
    }

    if (!authData.user.eduzzId) {
      console.error('Missing eduzzId in auth response');
      logout();
      return;
    }

    setAuthData({
      ...authData,
      user: {
        ...authData.user,
        eduzzId: authData.user.eduzzId!
      }
    });

    if (!authData.user.supportId) {
      initializePendo({ id: authData.user.id, name: authData.user.name, email: authData.user.email });
    }

    setAuthCompleted();
  }, [authData, setAuthCompleted, setAuthData]);

  useEffect(() => {
    if (!error) {
      return;
    }

    logout();
  }, [error]);

  return {
    refetch,
    error,
    isAuthenticated
  };
};
